module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/google_review-4f88cb7534491ae3ad3c67cde25a1b26.svg";